import { useNavigationGuard } from '@/services/navigation-guard';
import { useHistoryLeaveBlocker } from '@/services/navigation-guard/use-history-leave-blocker';

const LEAVE_MESSAGE = 'Save your changes or discard them to continue.';

type UseQueryTabGuardArgs = {
  /** Read live, not from render state. */
  hasUnsavedChanges: () => boolean;
  onDiscard: () => void;
};

/**
 * The unsaved-query prompt Ember showed on leaving the Query tabs: discard and go, or stay. A
 * query is saved from the tab itself, after a preview, so the prompt offers no save.
 */
export function useQueryTabGuard({ hasUnsavedChanges, onDiscard }: UseQueryTabGuardArgs) {
  const prompt = { hasUnsavedChanges, message: LEAVE_MESSAGE, onDiscard };
  // Hydra shell transitions and tab close/refresh.
  useNavigationGuard(prompt);
  // In-app history navigations and router links, which the guard above never hears.
  useHistoryLeaveBlocker(prompt);
}
